import React from 'react';
import styles from './style.module.scss';
/**
 * The pure css circular loader indicator component
 **/

var CSSProgressLoader = function CSSProgressLoader() {
  return React.createElement("div", {
    className: styles.ldsRing,
    style: {
      width: '43px',
      height: '43px',
      margin: '0 auto',
      position: 'relative',
      display: 'none'
    }
  }, React.createElement("div", null), React.createElement("div", null), React.createElement("div", null), React.createElement("div", null));
};

export default CSSProgressLoader;